
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","stroke-opacity":"0","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.17.17a.583.583 0 00-.12.65l6.594 14.834a.582.582 0 001.069-.008l2.378-5.555 5.557-2.38a.582.582 0 00.007-1.068L.82.05a.583.583 0 00-.648.12H.17z"}})])
          )
        }
      }
    